import { useAtomValue, useSetAtom } from 'jotai';
import { useMapClick, usePointerType } from '@/features/map';
import { cellAt } from '../model/result';
import { computeConeAtom } from '../state/actions';
import { inspectionAtom, resultAtom } from '../state/atoms';
import { ConeLayer } from './ConeLayer';
import { HoverPath } from './HoverPath';
import { CellLabel, OriginLabel } from './MapLabels';
import { NoResultPopup } from './NoResultPopup';
import { OriginMarker } from './OriginMarker';

/**
 * Everything the glide feature draws on the map. While `interactive`, a click sets the origin; on touch
 * screens, which cannot hover, a tap inside the result inspects that cell instead (its label offers to
 * move the origin). Stays mounted when not interactive, so the layers it syncs are kept up to date.
 */
export function GlideMapLayers({ interactive = true }: { interactive?: boolean }) {
  const compute = useSetAtom(computeConeAtom);
  const setInspection = useSetAtom(inspectionAtom);
  const result = useAtomValue(resultAtom);
  const pointer = usePointerType();

  useMapClick((e) => {
    if (!interactive) return;
    if (pointer.current !== 'mouse') {
      const k = cellAt(result, e.lngLat);
      if (k >= 0) {
        setInspection({ cell: k, at: e.lngLat, pinned: true });
        return;
      }
    }
    void compute({ lat: e.lngLat.lat, lng: e.lngLat.lng });
  });

  return (
    <>
      <ConeLayer />
      <HoverPath pointer={pointer} />
      <OriginMarker />
      <OriginLabel />
      <CellLabel />
      <NoResultPopup />
    </>
  );
}
